<style scoped>
.item-container {
  max-width: 20rem;
  margin: 0;
}

.item {
  padding: 1rem;
  border: solid black 1px;
  background-color: #fefefe;
}
.item-sub {
  margin: 0 0 0 1rem;
}
</style>

<template>
  <draggable
	v-bind="dragOptions"
	tag="div"
	class="item-container"
	:list="list"
	:value="value"
	@input="emitter"
  >
	<div class="item-group" :key="el.id" v-for="el in realValue">
	  <div class="nestable-item">
		  <div class="fold-buttons" v-if="el.children.length > 0 && code">
				<a href="#" @click="open=true" id="fold" v-if="!open"><i class="icon-arrow-right mr-2"></i></a>
				<a href="#" @click="open=false" id="fold" v-if="open"><i class="icon-arrow-down mr-2"></i></a>
		  </div>
		  <div class="nestable-item-content" :class="el.type == 'productclass' ? 'red' : ''">
			  <div class="row">
				  <div class="col-md-6">
					{{ el.name }} <span v-if="code">({{el.code}})</span>
				  </div>
				  <div class="col-md-6 text-right pull-right" v-if="el.type == 'category' || el.type == 'productclass'">
					<a href="#"><i class=" icon-note mr-2"></i></a>
				  </div>
			  </div>
				
		  </div>
		  <div class="sub-items" v-if="open && el.children.length > 0">
				<NestableItem class="item-sub" :list="el.children" v-if="el.children.length > 0" :code="code"/>
		  </div>
		</div>
	</div>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "NestableItem",
  methods: {
	emitter(value) {
	  this.$emit("input", value);
	},
  },
  components: {
	draggable
  },
  created(){
  },
  data () {
	return {
		open:true,
	}
  },
  computed: {
	dragOptions() {
	  return {
		animation: 0,
		group: "description",
		disabled: false,
		ghostClass: "ghost",
		swapThreshold:10
	  };
	},
	// this.value when input = v-model
	// this.list  when input != v-model
	realValue() {
	  return this.value ? this.value : this.list;
	}
  },
  props: {
	code:Boolean,
	groupOpts:Object,
	value: {
	  required: false,
	  type: Array,
	  default: null
	},
	list: {
	  required: false,
	  type: Array,
	  default: null
	}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Nestable/NestableItem.vue